import { combineReducers } from 'redux'
import {userReducer} from '../components/user/redux/reducers'
import { postReducer } from "../components/post/redux/reducers"
import { cellReducer } from "../components/cell/redux/reducers"
import { gridReducer } from "../components/grid/redux/reducers"


import { reducer as form } from 'redux-form'

const rootReducer = combineReducers({
  user: userReducer,
  posts: postReducer,
  cells: cellReducer,
  grid: gridReducer,
  form,
})

export default rootReducer
